import { useAuth } from 'context/auth/Auth'
import { useUser } from 'context/user/User'
import { hasRole, PRODUCER_ROLES } from 'helpers/dashboardAccess'
import PresentationBackground from 'modules/onboarding/common/PresentationBackground'
import React, { useCallback, useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import paths from 'routes/paths'
import PartnerForm from './form/PartnerForm'

export default function RegisterPartner() {
  const [searchParams] = useSearchParams();
  const { isAuth } = useAuth();
  const { user, getUser } = useUser();
  const [loadingUser, setLoadingUser] = useState(isAuth && !user?.id);

  useEffect(() => {
    const affiliateCode = searchParams.get('ref')?.trim().toUpperCase();

    if (affiliateCode) {
      localStorage.setItem('affiliateCode', affiliateCode);
    }
  }, [searchParams]);

  // Logado, o formulário depende dos dados e do papel da conta.
  useEffect(() => {
    if (!isAuth || user?.id) {
      setLoadingUser(false);
      return;
    }

    setLoadingUser(true);
    getUser().finally(() => setLoadingUser(false));
  }, [isAuth]);

  const existingAccount = isAuth && user?.id ? user : null;

  /* PresentationBackground renderiza isto como componente: uma função nova a
     cada render remontaria o formulário (e perderia os documentos) sempre que o
     contexto do usuário mudasse. Só troca quando troca a conta. */
  const Form = useCallback(
    () => <PartnerForm existingAccount={existingAccount} />,
    [existingAccount?.id]
  );

  if (loadingUser) {
    return null;
  }

  // Quem já é produtor (ou estabelecimento/admin) não tem o que pedir: cria o evento no painel.
  if (isAuth && hasRole(user, PRODUCER_ROLES)) {
    return <Navigate to={paths.dashboard.events} replace />;
  }

  return (
    <>
      <PresentationBackground
        ComponentToRender={Form}
        is='createPartner'
      />
    </>
  )
}
